import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { selectors } from '../../store/dux/cornrx-dux';
import Map from '../map/RxGoogleMap';

const layerConfig = [
  { id: 'cornrx', name: 'Corn Rx', visible: true },
  { id: 'ypt', name: 'YPT' },
];

export default function CornRxMap() {
  const planterSpacing = useSelector(selectors.planterSpacing);
  const filters = useMemo(() => ({ planterSpacing }), [planterSpacing]);
  return <Map layers={layerConfig} filters={filters} />;
}
